export default __webpack_public_path__ + "static/media/Onest-Bold.c761061e.woff2";